import React from "react";

import Context from "../../../context/Context";
import {DropdownButton} from "../../../common/components/Dropdown";
import Menu, {MenuItem} from "../../../common/components/Menu";
import {ModalController} from "../../../common/components/Modal";
import OfficePlan from "../../base/OfficePlan";
import SelectPerson from "./SelectPerson";
import SelectUnit from "./SelectUnit";
import Topic from "../../../context/Topic";
import UnassignPrompt from "./UnassignPrompt";
import * as component from "../../../components/util/component";
import * as officePlanUtil from "../../base/officePlanUtil";
import * as queryUtil from "../../base/queryUtil";
import * as transactions from "../../base/transaction/transactions";
import { ComboButton, Button } from "../../styles/Common/peopleAssignTo";
import AssignmentsPromptPeople from "./MultipleAssignments/AssignmentsPromptPeople";
import { getAttributes, getDuplicateCount, showUnassignModal, unassignAdditionalAssignments } from "./MultipleAssignments/multipleAssignmentsUtil";
import { getAttributeValue } from "../../../aiim/util/aiimUtil";
import FieldNames from "../../../aiim/datasets/FieldNames";
import TransactionGuard from "../../base/TransactionGuard";

export default class AreaAssignTo extends React.Component {

  constructor(props) {
    super(props);
    this.state = component.newState({});
    this.assignToClicked = this.assignToClicked.bind(this);
  }

  assignPersonToArea = (personFeatureItem, duplicatePeople) => {
    const areaItem = this.getAreaItem();
    const areaType = this.getAreaType();
    // TODO: Change this areas function
    transactions.assignPeopleToArea([personFeatureItem],areaItem,areaType,duplicatePeople).then(result => {
      Topic.publish(Topic.PlanModified,{
        action: OfficePlan.Action_AssignmentsUpdated
      });
      this.onAssignment();
    }).catch(error => {
      console.error("Error assigning person to area",error);
      Topic.publishErrorUpdatingData(error.submessage);
    });
  }

  duplicatePersonToArea = (personFeatureItem, duplicatePeople) => {
    const areaItem = this.getAreaItem()
    transactions.addPerson(personFeatureItem, null, areaItem, false, duplicatePeople).then(result => {
      Topic.publish(Topic.PlanModified,{
        action: OfficePlan.Action_AssignmentsUpdated
      });
      this.onAssignment();
    }).catch(error => {
      console.error("Error assigning person to area",error);
      Topic.publishErrorUpdatingData(error.submessage);
    });
  }

  assignToClicked(event,menuItem,value) {
    const option = menuItem.props.asnOption;
    if (value === "assignToPerson") {
      this.assignToPersonClicked(option.caption);
    } else if (value === "assignToUnit") {
      this.assignToUnitClicked(option.caption);
    } else if (value === "assignToNone") {
      this.assignToNoneClicked(option.caption);
    }
  }

  assignToPersonClicked(title) {
    const i18n = Context.instance.i18n
    SelectPerson.showModal({
      title: title,
      promptOptions: {
        subject: this.getAreaType(),
        subjectItems: [this.getAreaItem()],
        target: "person",
      },
      onOK: (sel) => {
        let objectId = (sel && sel.objectId);
        if (typeof objectId === "number") {
          const source =  officePlanUtil.getPeopleSource();
          const featureItem = queryUtil.makeFeatureItem(source,sel.feature);
          // this.assignPersonToArea(featureItem);
          let to = null
          if (this.getAreaType() === "hotel") to = i18n.spaceplanner.multipleAssignments.assignTo.hotel
          else if (this.getAreaType() === "hotdesk") to = i18n.spaceplanner.multipleAssignments.assignTo.hotdesk 
          let personAssignments  = null
          const setAssignments = (assignments) => {
            personAssignments = assignments
          }
          const onOK = (unassignAssignments, keepCurrentAssignment) => {
            if (unassignAssignments && keepCurrentAssignment) {
              unassignAdditionalAssignments(personAssignments, featureItem).then(duplicatePeople => {
                this.duplicatePersonToArea(featureItem, duplicatePeople)
              }).catch(e => {
                console.error("Couldn't remove additional assignments", e)
              })
            } else if (unassignAssignments) {
              unassignAdditionalAssignments(personAssignments, featureItem).then(duplicatePeople => {
                this.assignPersonToArea(featureItem, duplicatePeople)
              }).catch(e => {
                console.error("Couldn't remove additional assignments", e)
              })
            } else if (keepCurrentAssignment) {
              this.duplicatePersonToArea(featureItem)
            } else {
              this.assignPersonToArea(featureItem)
            }
          }
          showUnassignModal({
            personFeature: featureItem, 
            assignToFeature: this.getAreaItem(), 
            plural: false, 
            to: to, 
            showKeepCurrentAssignment: true,
            onOK: onOK,
            setAssignments: setAssignments
          })
        }
      }
    });
  }

  assignToUnitClicked(title) {
    SelectUnit.showModal({
      title: title,
      promptOptions: {
        subject: this.getAreaType(),
        subjectItems: [this.getAreaItem()],
        target: "unit",
      },
      onOK: (sel) => {
        let objectId = (sel && sel.objectId);
        if (typeof objectId === "number") {
          const source =  officePlanUtil.getUnitsSource();
          const featureItem = queryUtil.makeFeatureItem(source,sel.feature);
          this.assignUnitToArea(featureItem);
        }
      }
    });
  }

  assignToNoneClicked(title) {
    const i18n = Context.instance.i18n;
    const areaItem = this.getAreaItem();
    const areaType = this.getAreaType();
    const promptOptions = {
      subject: areaType,
      subjectItem: areaItem,
    };
    const content = <UnassignPrompt promptOptions={promptOptions}/>;
    const controller = new ModalController({});
    let okButton;
    let props = {
      title: title,
      showOKCancel: true,
      closeOnOK: true,
      okLabel: i18n.spaceplanner.unassign,
      onOK: () => {
        if (okButton) okButton.disable();
        // this.unassignAll();
      },
      onMountOKButton: (btn) => {
        okButton = btn;
      }
    };
    controller.show(props,content);
  }

  canAddToDuplicates = (duplicatePeople, totalCount, personName, personEmail) => {
    if (totalCount <= 1) return false
    let currentCount = 0
    duplicatePeople.forEach(person => {
      const personAttributes = getAttributes(person)
      const name = getAttributeValue(personAttributes, FieldNames.PEOPLE_FULLNAME)
      const email = getAttributeValue(personAttributes, FieldNames.PEOPLE_EMAIL)
      if (personName === name && personEmail === email) currentCount++
    })
    if (currentCount === (totalCount - 1)) return false
    else if (currentCount < (totalCount - 1)) return true
    else {
      console.warn("Inconsistent person assignments count")
      return false
    }
  }

  assignUnitToArea(unitFeatureItem) {
    const areaItem = this.getAreaItem();
    const areaType = this.getAreaType();
    const duplicatePeople = [], singleRecords = []
    const guard = new TransactionGuard({featureItems: [unitFeatureItem]});
    const unitPromise = officePlanUtil.queryPeopleAssignedToUnit(unitFeatureItem).then(people => {
      const peoplePromises = []
      people.forEach(person => {
        const personAttributes = getAttributes(person)
        const personName = getAttributeValue(personAttributes, FieldNames.PEOPLE_FULLNAME)
        const personEmail = getAttributeValue(personAttributes, FieldNames.PEOPLE_EMAIL)
        const personPromise = getDuplicateCount(personName, personEmail).then(count => {
          if (this.canAddToDuplicates(duplicatePeople, count, personName, personEmail)) {
            duplicatePeople.push(person)
          } else {
            singleRecords.push(person)
          }
        })
        peoplePromises.push(personPromise)
      })
      return Promise.all(peoplePromises)
    })
    unitPromise.then(() => {
      transactions.assignUnitsToArea([unitFeatureItem],areaItem,areaType, {
        duplicates: duplicatePeople,
        singleRecords: singleRecords
      }).then(result => {
        guard.close()
        Topic.publish(Topic.PlanModified,{
          action: OfficePlan.Action_AssignmentsUpdated
        });
        this.onAssignment();
      }).catch(error => {
        guard.close()
        console.error("Error assigning unit to area",error);
        Topic.publishErrorUpdatingData(error.submessage);
      });
    }).catch(e => {
      guard.close()
      console.error("Error assigning unit to area", e);
      Topic.publishErrorUpdatingData(e.submessage);
    })
    
  }

  componentDidMount() {}

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  getAreaItem() {
    return this.state.areaItem || this.props.areaItem;
  }

  getAreaType() {
    return this.state.areaType || this.props.areaType;
  }

  onAssignment() {
    if (typeof this.props.onAssignment === "function") {
      this.props.onAssignment();
    }
  }

  render() {
    if (this.props.isPopup) {
      return this.renderPopupAssignButton()
    } else {
      const dropdown = this.renderAssignToDropdown();
      return dropdown;
    }
  }

  renderAssignToDropdown() {
    const i18n = Context.instance.i18n;
    const areaType = this.getAreaType();
    let i18nAreas;
    if (areaType === OfficePlan.SpaceAssignmentTypes.hotdesk) {
      i18nAreas = i18n.spaceplanner.hotdeskAreas;
    } else {
      i18nAreas = i18n.spaceplanner.hotelAreas;
    }
    const options = [
      {
        label: i18nAreas.assignTo.person.label,
        caption: i18nAreas.assignTo.person.caption,
        value: "assignToPerson"
      },
      {
        label: i18nAreas.assignTo.unit.label,
        caption: i18nAreas.assignTo.unit.caption,
        value: "assignToUnit"
      },
      {
        label: i18n.spaceplanner.unassign,
        caption: i18n.spaceplanner.unassignPrompt.removeAssignmentsTitle,
        value: "assignToNone"
      }
    ]

    const menuItems = [];
    options.forEach(option => {
      menuItems.push(
        <MenuItem key={option.value} value={option.value} asnOption={option}
          onClick={this.assignToClicked}
        >{option.label}</MenuItem>
      );
    });
    const buttonProps= {
      extraSmall: true
    };
    const buttonContent = (<span>{i18nAreas.assignTo.label}</span>);
    const dropdownContent = (<Menu className="i-dd-menu">{menuItems}</Menu>);

    //buttonClassName={"i-margin-lr"}

    const dropdown = (
      <DropdownButton
        closeOnSelect={true}
        focusFirst={true}
        buttonContent={buttonContent}
        buttonProps={buttonProps}
        buttonClassName={this.props.buttonClassName}
        dropdownContent={dropdownContent}
        placement={this.props.placement}>
      </DropdownButton>
    );
    return dropdown;
  }

  renderPopupAssignButton = () => {
    const i18n = Context.instance.i18n
    const type = this.props.areaType
    const tab = this.props.tab
    let option, value, i18nAreas
    if (type === "hotel") {
      i18nAreas = i18n.spaceplanner.hotelAreas
    } else if (type === "hotdesk") {
      i18nAreas = i18n.spaceplanner.hotdeskAreas
    }
    if (i18nAreas && tab === "people") {
      option = {
        props: {
          asnOption: {
            caption: i18nAreas.assignTo.person.caption
          }
        }
      }
      value = "assignToPerson"
    } else if (i18nAreas && tab === "units") {
      option = {
        props: {
          asnOption: {
            caption: i18nAreas.assignTo.unit.caption
          }
        }
      }
      value = "assignToUnit"
    }
    return (
      <Button className={"i-assign-btn"}
        onClick={e => {
          this.assignToClicked(e, option, value)
        }}><span>{i18n.spaceplanner.popup.assignBtn}</span>
      </Button>
    )
  }

  // unassignAll() {
  //   const areaItem = this.getAreaItem();
  //   const areaType = this.getAreaType();
  //   officePlanUtil.unassignArea(areaItem,areaType).then(result => {
  //     Topic.publish(Topic.PlanModified,{
  //       action: OfficePlan.Action_AssignmentsUpdated
  //     });
  //     this.onAssignment();
  //   }).catch(error => {
  //     console.error("Error unassigning area",error);
  //     Topic.publishErrorUpdatingData(error.submessage);
  //   });
  // }

}
